import { render, staticRenderFns } from "./IndicatorModal.vue?vue&type=template&id=60be788a"
import script from "./IndicatorModal.vue?vue&type=script&lang=js"
export * from "./IndicatorModal.vue?vue&type=script&lang=js"
import style0 from "./IndicatorModal.vue?vue&type=style&index=0&id=60be788a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports